import { apiConstructor } from './../../api/ConstructorApi'


let variableFlaps =[
]

function initVariableFlaps() {
    return new Promise((resolve, reject) => {
        apiConstructor.getFlapVariations()
        .then(res => {
            variableFlaps = res.data 
            resolve(true)
        })
        .catch(res => {
            reject(false)
        })
    })
}

export {variableFlaps, initVariableFlaps}